declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { HCPService } from '../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController, ActorContactInfoController, ActorContactInfoRequest } from '../../../models/profileinfo/profileinfo.model';
import { ActorImageController, OTFormsByFormattedCodeController, OTFormDetailByReportCodeRequest, OTFormsByFormattedCodeRequest, OTFormDetailByReportCodeController, SectionData, FormOrganizer, X_BillHeaderController, x_BillDetailsRequest, BillDetailsInfoController, X_BillItemsController, X_BillReceiptsController, GenerateIahOrderFromBillRequest, SaveDeletedBillItemRequest, GenericProcPostRequest, S_Methods, BillItemsByChargeEntryCodeRequest } from '../../../models/actor/actor';
//import { NgxMaskModule } from 'ngx-mask';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../services/datetime.service';
//import './profilesteps.js';
//declare var mess1: any;
//declare var stepObject: any;
//declare var pSteps: any;
//declare var webGlObject: any;

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';


import { PrintService } from '../../../../../../src/app/ncs/services/print.service';


import { NgxSpinnerService } from 'ngx-spinner';
import { NgbAddbilladv } from './modal/addbilladv.modal';
@Component({
  selector: 'billprofile',
  templateUrl: './billprofile.component.html',
  styleUrls: ['./billprofile.component.scss']
})

export class BillProfileComponent implements OnInit {

  @Input() ActorCode: number;
  @Input() ActorType: number;
  @Input() FormattedCode: string;
  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() PatientCode: number;

  public isRequesting: boolean = false;

  public BillsList: boolean = true;
  public BillsDetails: boolean = false;
  public ApiResData: ApiResponseModel;

  public MaxDateV = new Date();
  public MinDateV = new Date();
  public PatientFormattedCode: string;
  public PatientName: string;
  public PayeeName: string;
  public Toatalbill: number;
  public PaidBill: number;
  DOB: NgbDateStruct;

  CurrentGenerateIahOrderFromBillRequest: GenerateIahOrderFromBillRequest;

  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  public TotalAmount: number;
  public TotalPaid: number;
  public TotalDue: number;
  public TotalAdvance: number;
  public TotalDiscount: number;

  //
  public key: ActorPersonalDetailInfoController;


  @Input()
  get Key() {
    return this.key;
  }

  @Output() personalInfoChange = new EventEmitter();
  public ChargeEntryCode: number;
  CurrentBillDetailsInfoController: X_BillHeaderController[];
  BillCodesOP: X_BillHeaderController[];
  BillCodesRX: X_BillHeaderController[];
  BillCodesOPAdv: X_BillHeaderController[];
  Currentx_BillDetailsRequest: x_BillDetailsRequest;

  LoadForms() {
    this.Currentx_BillDetailsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.Currentx_BillDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentBillDetailsInfoController;
    this.GetBillDetailsInfoController();
  }
  GetBillDetailsInfoController() {
    this.StartRefreshing();
    this.Currentx_BillDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    var d1 = new Date();
    d1.setFullYear(d1.getFullYear() - 20);
    this.Currentx_BillDetailsRequest.FromDate = d1;
    this.Currentx_BillDetailsRequest.ToDate = new Date();
    this.Currentx_BillDetailsRequest.ChargeEntry = 0;
    this.Currentx_BillDetailsRequest.ConditionalOperator = 9;
    this.Currentx_BillDetailsRequest.ActorCode = this.ActorCode;
    this.Currentx_BillDetailsRequest.FormattedCode = this.FormattedCode || this.PatientFormattedCode || '';
    this.Currentx_BillDetailsRequest.BillType = '';
    this.Currentx_BillDetailsRequest.SearchText = '';

    this.actorservice.GetBillDetailsInfoController(this.Currentx_BillDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError && this.ApiResData.Result && this.ApiResData.Result.length > 0) {
          this.ProcessBillsData(this.ApiResData.Result);
          this.stopRefreshing();
        } else {
          // If ConditionalOperator 9 returned empty, retry with ConditionalOperator 30 using FormattedCode
          this.Currentx_BillDetailsRequest.ConditionalOperator = 30;
          this.Currentx_BillDetailsRequest.FormattedCode = this.FormattedCode || this.PatientFormattedCode || '';
          this.actorservice.GetBillDetailsInfoController(this.Currentx_BillDetailsRequest)
            .subscribe((result30) => {
              this.ApiResData = result30;
              if (!this.ApiResData.hasError && this.ApiResData.Result && this.ApiResData.Result.length > 0) {
                this.ProcessBillsData(this.ApiResData.Result);
              } else {
                this.ProcessBillsData([]);
              }
              this.stopRefreshing();
            }, (error) => {
              this.ProcessBillsData([]);
              this.stopRefreshing();
            });
        }
      },
      (error) => {
        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        } else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      });
  }

  ProcessBillsData(data: X_BillHeaderController[]) {
    this.CurrentBillDetailsInfoController = data || [];
    if (this.CurrentBillDetailsInfoController && this.CurrentBillDetailsInfoController.length > 0) {
      this.TotalAmount = this.CurrentBillDetailsInfoController.reduce((sum, current) => sum + (current.TotalAmount || current.ItemTotal || 0), 0);
      this.TotalPaid = this.CurrentBillDetailsInfoController.reduce((sum, current) => sum + (current.PaidTotal || current.Paid || 0), 0);
      this.TotalDue = this.CurrentBillDetailsInfoController.reduce((sum, current) => sum + (current.Balance || 0), 0);
      this.TotalDiscount = this.CurrentBillDetailsInfoController.reduce((sum, current) => sum + (current.Discount || 0), 0);
      this.ChargeEntryCode = this.CurrentBillDetailsInfoController[0].ChargeEntry;

      var filterMap = new Map<string, X_BillHeaderController>();
      for (let item of this.CurrentBillDetailsInfoController) {
        var key = (item.ChargeEntry && item.ChargeEntry > 0) ? ('CE_' + item.ChargeEntry) 
                : (item.FormattedCode && item.FormattedCode !== '') ? ('FC_' + item.FormattedCode)
                : (item.BillNo && item.BillNo !== '') ? ('BN_' + item.BillNo)
                : ('R_' + Math.random());
        if (!filterMap.has(key)) {
          filterMap.set(key, item);
        }
      }
      var filterArray = Array.from(filterMap.values());

      this.BillCodesOP = filterArray.filter(a => {
        var bt = (a.BillType || '').toUpperCase();
        return bt !== 'RXBILL' && bt !== 'RX';
      });

      this.BillCodesRX = filterArray.filter(b => {
        var bt = (b.BillType || '').toUpperCase();
        return bt === 'RXBILL' || bt === 'RX';
      });

      this.BillCodesOPAdv = filterArray.filter(b => {
        var bt = (b.BillType || '').toUpperCase();
        return bt === 'OPADVC' || bt === 'OPADV';
      });

      this.TotalAdvance = this.BillCodesOPAdv.reduce((sum, current) => sum + (current.PaidTotal || current.Paid || 0), 0);
    } else {
      this.TotalAmount = 0;
      this.TotalPaid = 0;
      this.TotalDue = 0;
      this.TotalDiscount = 0;
      this.BillCodesOP = [];
      this.BillCodesRX = [];
      this.BillCodesOPAdv = [];
      this.TotalAdvance = 0;
    }
  }

  constructor(private router: Router,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService, private actorservice: ActorService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private spinner: NgxSpinnerService, private tosterservice: NGXToastrService) {
    //stepObject.init();
  }

  ngOnInit() {

    this.PatientFormattedCode = this.FormattedCode;
    this.CurrentGenerateIahOrderFromBillRequest = new GenerateIahOrderFromBillRequest();
    this.CurrentGenerateIahOrderFromBillRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadForms();

  }

  SelectedpatientDetails: X_BillHeaderController;
  Selectedpatient(objCategory: any) {
    var patient: X_BillHeaderController = objCategory;
    if (patient != null) {
      this.SelectedpatientDetails = patient;
      this.CurrentX_BillHeaderController = patient;
      this.BillsList = false;
      this.BillsDetails = true;
      this.LoadBillHeader();
      this.LoadBillItems();
      this.LoadBillReceipts();
    }
  }

  GetItemsOP(item: any) {
    if (!item) return [];
    if (typeof item === 'string') {
      var matchStr = this.CurrentBillDetailsInfoController.filter(X => X.BillNo === item || X.FormattedCode === item);
      return matchStr.length > 0 ? matchStr : [];
    }
    if (item.ChargeEntry && item.ChargeEntry > 0) {
      var match = this.CurrentBillDetailsInfoController.filter(X => X.ChargeEntry === item.ChargeEntry);
      if (match && match.length > 0) return match;
    }
    if (item.FormattedCode && item.FormattedCode !== '') {
      var match2 = this.CurrentBillDetailsInfoController.filter(X => X.FormattedCode === item.FormattedCode);
      if (match2 && match2.length > 0) return match2;
    }
    if (item.BillNo && item.BillNo !== '') {
      var match3 = this.CurrentBillDetailsInfoController.filter(X => X.BillNo === item.BillNo);
      if (match3 && match3.length > 0) return match3;
    }
    return [item];
  }

  GetItemsRX(item: any) {
    if (!item) return [];
    if (typeof item === 'string') {
      var matchStr = this.CurrentBillDetailsInfoController.filter(X => X.BillNo === item || X.FormattedCode === item);
      return matchStr.length > 0 ? matchStr : [];
    }
    if (item.ChargeEntry && item.ChargeEntry > 0) {
      var match = this.CurrentBillDetailsInfoController.filter(X => X.ChargeEntry === item.ChargeEntry);
      if (match && match.length > 0) return match;
    }
    if (item.FormattedCode && item.FormattedCode !== '') {
      var match2 = this.CurrentBillDetailsInfoController.filter(X => X.FormattedCode === item.FormattedCode);
      if (match2 && match2.length > 0) return match2;
    }
    if (item.BillNo && item.BillNo !== '') {
      var match3 = this.CurrentBillDetailsInfoController.filter(X => X.BillNo === item.BillNo);
      if (match3 && match3.length > 0) return match3;
    }
    return [item];
  }
  CurrentX_BillHeaderController: X_BillHeaderController;
  CurrentX_BillHeaderRequest: x_BillDetailsRequest;

  BillDataHeader: BillDetailsInfoController;

  LoadBillHeader() {
    this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
    this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderController();
  }

  GetX_BillHeaderController() {
    if (!this.SelectedpatientDetails) return;
    var ce = this.SelectedpatientDetails.ChargeEntry || (this.SelectedpatientDetails as any).ChargeEntryCode || (this.SelectedpatientDetails as any).Code || 0;
    this.CurrentX_BillHeaderRequest.ChargeEntry = ce;
    this.CurrentX_BillHeaderRequest.ConditionalOperator = 5;

    this.actorservice.GetBillHeaderController(this.CurrentX_BillHeaderRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError && this.ApiResData.Result) {
          var resData = this.ApiResData.Result;
          this.BillDataHeader = resData;

          var headerObj = null;
          if (resData.Header) {
            headerObj = Array.isArray(resData.Header) ? resData.Header[0] : resData.Header;
          } else if (Array.isArray(resData) && resData.length > 0 && resData[0] && (resData[0].TotalAmount || resData[0].BillCreatedDate || resData[0].BranchName)) {
            headerObj = resData[0];
          } else if (resData && !Array.isArray(resData) && (resData.TotalAmount || resData.BillCreatedDate || resData.BranchName)) {
            headerObj = resData;
          }

          if (headerObj) {
            this.CurrentX_BillHeaderController = headerObj;
          }

          var items = resData.Items || resData.Details || resData.BillItems;
          if (items && Array.isArray(items) && items.length > 0) {
            this.CurrentX_BillItemsController = items;
          }

          var rcpts = resData.Receipts || resData.Payments || resData.BillReceipts;
          if (rcpts && Array.isArray(rcpts) && rcpts.length > 0) {
            this.CurrentX_BillReceiptsController = rcpts;
          }
        }
      },
      (error) => {
        // Keep initial patient object as fallback
      });
  }
  CurrentX_BillItemsController: X_BillItemsController[];
  //FollicularScanEndInfo: FollicularScanDetailController;
  //BillHeader: X_BillHeaderController[];
  CurrentX_BillItemsRequest: x_BillDetailsRequest;
  BillData: BillDetailsInfoController;

  LoadBillItems() {
    //alert("ScansData")
    this.CurrentX_BillItemsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillItemsController();
  }

  GetX_BillItemsController() {
    if (!this.SelectedpatientDetails) return;
    var ce = this.SelectedpatientDetails.ChargeEntry || (this.SelectedpatientDetails as any).ChargeEntryCode || (this.SelectedpatientDetails as any).Code || 0;
    if (ce <= 0) return;

    this.CurrentX_BillItemsRequest.ChargeEntry = ce;
    this.CurrentX_BillItemsRequest.ConditionalOperator = 5;

    this.actorservice.GetBillItemsController(this.CurrentX_BillItemsRequest)
      .subscribe((result) => {
        if (!result.hasError && result.Result) {
          var resData = result.Result;
          var items: any[] = [];
          if (Array.isArray(resData)) {
            items = resData;
          } else if (resData.Items) {
            items = Array.isArray(resData.Items) ? resData.Items : [resData.Items];
          } else if (resData.Details) {
            items = Array.isArray(resData.Details) ? resData.Details : [resData.Details];
          }
          if (items && items.length > 0) {
            this.CurrentX_BillItemsController = items;
          }
        }
      },
      (error) => {
        // preserve existing items array
      });
  }

  CurrentX_BillReceiptsController: X_BillReceiptsController[];
  CurrentX_BillReceiptsRequest: x_BillDetailsRequest;
  BillDataReceipt: BillDetailsInfoController;

  LoadBillReceipts() {
    this.CurrentX_BillReceiptsRequest = new x_BillDetailsRequest();
    this.CurrentX_BillReceiptsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillReceiptsController();
  }

  GetX_BillReceiptsController() {
    if (!this.SelectedpatientDetails) return;
    var ce = this.SelectedpatientDetails.ChargeEntry || (this.SelectedpatientDetails as any).ChargeEntryCode || (this.SelectedpatientDetails as any).Code || 0;
    if (ce <= 0) return;

    this.CurrentX_BillReceiptsRequest.ChargeEntry = ce;
    this.CurrentX_BillReceiptsRequest.ConditionalOperator = 5;

    this.actorservice.GetBillReceiptsController(this.CurrentX_BillReceiptsRequest)
      .subscribe((result) => {
        if (!result.hasError && result.Result) {
          var resData = result.Result;
          var rcpts: any[] = [];
          if (Array.isArray(resData)) {
            rcpts = resData;
          } else if (resData.Receipts) {
            rcpts = Array.isArray(resData.Receipts) ? resData.Receipts : [resData.Receipts];
          } else if (resData.Payments) {
            rcpts = Array.isArray(resData.Payments) ? resData.Payments : [resData.Payments];
          }
          if (rcpts && rcpts.length > 0) {
            this.CurrentX_BillReceiptsController = rcpts;
            this.PatientName = rcpts[0].PatientName || '';
            this.PayeeName = rcpts[0].PayeeName || '';
            this.Toatalbill = rcpts[0].AmountPayable || 0;
            this.PaidBill = rcpts[0].AmountPaid || 0;
          }
        }
      },
      (error) => {
        // preserve existing receipts array
      });
  }
  SelectedItemDetails: X_BillItemsController;
  SelectedItem(objCategory: any) {
    var Item: X_BillItemsController = objCategory;
    if (Item != null) {
      this.SelectedItemDetails = null;
      this.SelectedItemDetails = Item;
      this.DeleteItem();
    }
  }
  DeleteItem() {
    var saveReq = new SaveDeletedBillItemRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40052;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.ActionTag = "Delete";
    //saveReq.DoccumentType = 101;
    saveReq.ChargeEntry = this.SelectedItemDetails.ChargeEntry;
    saveReq.ItemCode = this.SelectedItemDetails.ItemCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40052;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.LoadBillItems();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  items() {
    let m = document.querySelector("#items");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Receipts() {
    let m = document.querySelector("#Receipts");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  BackToBillsList() {
    this.BillsList = true;
    this.BillsDetails = false;
  }
  billeditRX() {
    const fmtCode = this.PatientFormattedCode || this.FormattedCode || (this.SelectedpatientDetails ? (this.SelectedpatientDetails.PatientFormattedCode || this.SelectedpatientDetails.FormattedCode) : '') || (this.CurrentX_BillHeaderController ? (this.CurrentX_BillHeaderController.PatientFormattedCode || this.CurrentX_BillHeaderController.FormattedCode) : '') || '';
    const ce = (this.CurrentX_BillHeaderController ? this.CurrentX_BillHeaderController.ChargeEntry : 0) || (this.SelectedpatientDetails ? this.SelectedpatientDetails.ChargeEntry : 0);
    const status = (this.CurrentX_BillHeaderController ? this.CurrentX_BillHeaderController.BillStatus : '') || (this.SelectedpatientDetails ? this.SelectedpatientDetails.BillStatus : '');
    this.router.navigate(['healins/rxreceiptedit', {
      FormattedCodedata: fmtCode,
      ChargeEntryCode: ce,
      BillStatus: status
    }]);
  }
  billeditOP() {
    const fmtCode = this.PatientFormattedCode || this.FormattedCode || (this.SelectedpatientDetails ? (this.SelectedpatientDetails.PatientFormattedCode || this.SelectedpatientDetails.FormattedCode) : '') || (this.CurrentX_BillHeaderController ? (this.CurrentX_BillHeaderController.PatientFormattedCode || this.CurrentX_BillHeaderController.FormattedCode) : '') || '';
    const ce = (this.CurrentX_BillHeaderController ? this.CurrentX_BillHeaderController.ChargeEntry : 0) || (this.SelectedpatientDetails ? this.SelectedpatientDetails.ChargeEntry : 0);
    const status = (this.CurrentX_BillHeaderController ? this.CurrentX_BillHeaderController.BillStatus : '') || (this.SelectedpatientDetails ? this.SelectedpatientDetails.BillStatus : '');
    this.router.navigate(['healins/receiptedit', {
      FormattedCodedata: fmtCode,
      ChargeEntryCode: ce,
      BillStatus: status
    }]);
  }
  AddNewBill() {

    this.router.navigate(['healins/receipt']);
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  ConvertToIah() {
    //alert("Code");
    this.CurrentGenerateIahOrderFromBillRequest.ConditionalOperator = 10;
    this.CurrentGenerateIahOrderFromBillRequest.ChargeEntryCode = this.SelectedpatientDetails.ChargeEntry;
    this.actorservice.GenerateIahOrderFromBill(this.CurrentGenerateIahOrderFromBillRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            // this.Listview = true;
            //this.EditEmbryo = false;
            //this.LoadStoreData();
            //this.AddEmbryo = false;
            //this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();
            this.router.navigate(['healins/ConsumptionEntry']);
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");

            //this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            //this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            // this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            // this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }

  opbill() {
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("opbill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.Branch, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.OverAllDiscount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  opbillSvc_Provider() {
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("opbillSvc_Provider",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry,
        PatientId: this.SelectedpatientDetails.PatientFormattedCode,
        Owner: this.SelectedpatientDetails.PatientName,
        Gender: this.SelectedpatientDetails.PatientGender,
        Age: this.SelectedpatientDetails.PatientAgeY,
        BillDate: this.SelectedpatientDetails.BillDate,
        BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName,
        ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode,
        GrandTotal: this.SelectedpatientDetails.TotalAmount,
        Discount: this.SelectedpatientDetails.Discount,
        Tax: this.SelectedpatientDetails.Tax,
        Net: this.SelectedpatientDetails.Net,
        Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  ipadvbill() {
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument("advreceipt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.Branch, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.OverAllDiscount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  opadvbill() {
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument("advreceipt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.Branch, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.OverAllDiscount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  rxbill() {
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument3(this.CurrentX_BillHeaderController.BillNo, 0

    );
    this.printService.printDocument4('0', this.SelectedpatientDetails.ChargeEntry

    );
    this.printService.printDocument("pharmacybill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry,
        PatientId: this.SelectedpatientDetails.PatientFormattedCode,
        Owner: this.SelectedpatientDetails.PatientName,
        Gender: this.SelectedpatientDetails.PatientGender,
        Age: this.SelectedpatientDetails.PatientAgeY,
        BillDate: this.SelectedpatientDetails.BillDate,
        BillNo: this.CurrentX_BillHeaderController.BillNo,
        ReceiptFormattedCode: this.CurrentX_BillHeaderController.ReceiptFormattedCode,
        Branch: this.SelectedpatientDetails.Branch,
        GrandTotal: this.SelectedpatientDetails.TotalAmount,
        Discount: this.SelectedpatientDetails.OverAllDiscount,
        Tax: this.SelectedpatientDetails.Tax,
        Net: this.SelectedpatientDetails.Net,
        Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  Addbill() {
    this.router.navigate(['healins/receiptold', { FormattedCode: this.FormattedCode }]);
  }
  Addbill_withSvcProvider() {
    this.router.navigate(['healins/receipt_svcprovider', { FormattedCode: this.FormattedCode }]);
  }
  AddAdv() {
    const modalRef = this.modalService.open(NgbAddbilladv,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.FomattedCode = this.FormattedCode;
    modalRef.componentInstance.Type = "FromProfile"
    modalRef.result.then(x => { this.GetBillDetailsInfoController() })
  }
}
